export const GET_DATA_ANALYTIC = "GET_DATA_ANALYTIC"
export const GET_DATA_ANALYTIC_ERR = "GET_DATA_ANALYTIC_ERR"